import { render, staticRenderFns } from "./AnonDark.vue?vue&type=template&id=af968058&"
import script from "./AnonDark.vue?vue&type=script&lang=ts&"
export * from "./AnonDark.vue?vue&type=script&lang=ts&"
import style0 from "./AnonDark.vue?vue&type=style&index=0&id=af968058&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports